export const UPDATE_QUERY_FILTERS = "UPDATE_QUERY_FILTERS";
export const UPDATE_QUERY_SEARCH = "UPDATE_QUERY_SEARCH";

export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

export const FETCH_VIDEOS_SUCCESS = "FETCH_VIDEOS_SUCCESS";
export const FETCH_VIDEO_SUCCESS = "FETCH_VIDEO_SUCCESS";

export const FETCH_VIDEOS_FAILURE = "FETCH_VIDEOS_FAILURE";
export const FETCH_VIDEO_FAILURE = "FETCH_VIDEO_FAILURE";

export const FETCHING_VIDEOS = "FETCHING VIDEOS";